import { useEffect, useState } from 'react';
import type { MovelViewer } from '../three/viewerCore.js';

/**
 * Painel de desempenho, so com ?debug=1 na URL. Serve para medir no aparelho de
 * verdade (ex.: o tablet da marcenaria) sem ferramenta nenhuma: abra o projeto,
 * gire a camera e leia os numeros.
 */
export function PainelDesempenho({ viewer }: { viewer: MovelViewer | null }) {
  const [m, setM] = useState<ReturnType<MovelViewer['metricas']> | null>(null);
  useEffect(() => {
    if (!viewer) return;
    (window as unknown as { __mania3d?: MovelViewer }).__mania3d = viewer;
    const id = window.setInterval(() => setM(viewer.metricas()), 500);
    return () => window.clearInterval(id);
  }, [viewer]);
  if (!m) return null;
  // A tela so redesenha quando algo muda: parada, o "fps" cairia a zero sem ser
  // problema. Mostra "parado" e o fps so enquanto a camera se move.
  const parado = m.ociosoMs > 1000;
  const cor = parado || m.fps >= 50 ? '#8be34a' : m.fps >= 30 ? '#ffd166' : '#ff5252';
  return (
    <div className="painel-desempenho" aria-hidden="true">
      {parado
        ? <><b style={{ color: cor }}>parado</b> · sem redesenhar (gire para medir)</>
        : <><b style={{ color: cor }}>{m.fps} fps</b> · quadro {m.quadroMs}ms · render {m.renderMs}ms</>}<br />
      draw calls {m.drawCalls} · triângulos {m.triangulos.toLocaleString('pt-BR')} · peças {m.pecas}<br />
      pixel ratio {m.pixelRatio} · geometrias {m.geometrias}
    </div>
  );
}
